/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSdk = createReactComponent("outline", "sdk", "IconSdk", [["path", { "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3", "key": "svg-0" }], ["path", { "d": "M17 8v8", "key": "svg-1" }], ["path", { "d": "M21 8l-3 4l3 4", "key": "svg-2" }], ["path", { "d": "M17 12h1", "key": "svg-3" }], ["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-4" }]]);

export { IconSdk as default };
//# sourceMappingURL=IconSdk.mjs.map
